if (!customElements.get("countdown-timer")) {
    const dayInMs = 86400000;
    const hourInMs = 3600000;
    const minuteInMs = 60000;
    const secondInMs = 1000;
    const dayInHours = 24;
    const hourInMinutes = 60;
    const minuteInSeconds = 60;
  
    customElements.define(
      "countdown-timer",
      class CountdownTimer extends HTMLElement {
        constructor() {
          super();
  
          this.date = new Date(this.dataset.date);
        }
  
        connectedCallback() {
          this.previous = new Date();
          this.interval = setInterval(this.render.bind(this), 1000);
        }
  
        disconnectedCallback() {
          clearInterval(this.interval);
        }
  
        getDifferenceInMilliseconds(dateLeft, dateRight) {
          return dateLeft.getTime() - dateRight.getTime();
        }
  
        getRemainingDays(dateLeft, dateRight) {
          const difference =
            this.getDifferenceInMilliseconds(dateLeft, dateRight) / dayInMs;
  
          return Math.floor(difference);
        }
  
        getRemainingHours(dateLeft, dateRight) {
          const difference =
            this.getDifferenceInMilliseconds(dateLeft, dateRight) / hourInMs;
  
          return Math.floor(difference % dayInHours);
        }
  
        getRemainingMinutes(dateLeft, dateRight) {
          const difference =
            this.getDifferenceInMilliseconds(dateLeft, dateRight) / minuteInMs;
  
          return Math.floor(difference % hourInMinutes);
        }
  
        getRemainingSeconds(dateLeft, dateRight) {
          const difference =
            this.getDifferenceInMilliseconds(dateLeft, dateRight) / secondInMs;
  
          return Math.floor(difference % minuteInSeconds);
        }
  
        render() {
          const next = new Date();
  
          if (next >= this.date) {
            clearInterval(this.interval);
            this.closest(".countdown")?.classList.remove("active");
            return;
          } else {
            this.closest(".countdown")?.classList.add("active");
          }
          const timings = {
            days: {
            //   previous: this.getRemainingDays(this.date, this.previous),
              next: this.getRemainingDays(this.date, next),
            },
            hours: {
            //   previous: this.getRemainingHours(this.date, this.previous),
              next: this.getRemainingHours(this.date, next),
            },
            minutes: {
            //   previous: this.getRemainingMinutes(this.date, this.previous),
              next: this.getRemainingMinutes(this.date, next),
            },
            seconds: {
            //   previous: this.getRemainingSeconds(this.date, this.previous),
              next: this.getRemainingSeconds(this.date, next),
            },
          };
  
          Object.keys(timings).forEach((unit) => {
            const containerElement = this.querySelector(`[class~="${unit}"]`);
  
            if (!containerElement) return;
  
            containerElement.classList.remove("flip");
  
            // containerElement.querySelectorAll(".previous").forEach((element) => {
            //   element.innerText = timings[unit].previous.toString().padStart(2, "0");
            // });
            containerElement.querySelectorAll(".next").forEach((element) => {
              element.innerText = timings[unit].next.toString().padStart(2, "0");
              if(
                unit == 'days' && timings[unit].next === 0 ||
                unit == 'hours' && timings['days'].next === 0 && timings[unit].next === 0 ||
                unit == 'minutes' && timings['days'].next === 0 && timings['hours'].next === 0 && timings[unit].next === 0 ||
                unit == 'seconds' && timings['days'].next === 0 && timings['hours'].next === 0 && timings['minutes'].next === 0 && timings[unit].next === 0
              ) {
                element.closest(".section").classList.add("hidden");
              }
            });

            if (timings[unit].next !== timings[unit].previous) {
              requestAnimationFrame(() => {
                containerElement.classList.add("flip");
              });
            }
          });
  
          this.previous = next;
        }
      }
    );
  }
  